
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiViewSingleGoogle as ObiViewSingleGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-view-single-google.js';
 
 
 

 
 export const ObiViewSingleGoogle = createComponent({
   react: React,
   tagName: 'obi-view-single-google',
   elementClass: ObiViewSingleGoogleElement,
   events: {
     
   }
  });
 
 